//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { htmlEncode } from 'app/utils/htmlEncode';

/**
 * Filters for escaping HTML entities within text
 *
 * htmlEncode:
 *  Returns an string with all html entities escaped.
 *  The output is returned as a trusted html string, so it can be passed to ng-bind-html or other similar directives.
 *
 *  Example Usage:
 *      <span class="address">{{ user.instagramBioText | htmlEncode }}</span>
 *      <span class="address" ng-bind="'<script>alert(1);</script>' | htmlEncode"><span>
 *
 */

(function() {
  angular.module('curalate')
    .filter('htmlEncode', [
      '$sce',
      function(
            $sce,
        ) {
        return function(input) {
          return $sce.trustAsHtml(htmlEncode(input));
        };
      }]);
})();
